function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.6615 1.88826C14.0391 1.51062 14.694 1.49536 15.1161 1.89314C15.4892 2.27171 15.5025 2.92324 15.1058 3.34354L14.298 4.15137L12.8482 2.70156L13.6615 1.88826ZM15.9498 1.02998C15.0753 0.195175 13.6714 0.181332 12.813 1.03973L11.1511 2.70156L14.298 5.84843L15.9599 4.18671L15.9696 4.17662C16.8044 3.30206 16.8183 1.89801 15.9599 1.03961L15.9498 1.02998ZM13.8472 6.42591L10.5736 3.15234L2.99772 10.6944L0.962402 16.0371L6.3051 14.0018L13.8472 6.42591ZM3.03676 13.9627L4.02723 11.3628L10.5717 4.8475L12.152 6.42781L5.63675 12.9723L3.03676 13.9627Z",
  fill: "#27262A"
});

var SvgPencil = function SvgPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil.5dc21386.svg";
export { ForwardRef as ReactComponent };